export const normalizeApiUrl = (url?: string) => (url ? url.replace(/^(api\/admin|\/api\/admin)/g, '') : '')
